<template>
  <div>
    <!-- หน้ารอโหลด -->
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <!-- ปุ่มสำหรับเพิ่มสถานที่ -->
      <div class="btn-space">
        <b-button
          variant="primary"
          @click="showAddDeptModal"
        >
          {{ $t('add') }}
        </b-button>
      </div>
      <!-- Container สำหรับปุ่มค้นหาและปุ่มเพิ่ม -->
      <!-- ช่องค้นหาและปุ่มค้นหา -->
      <div class="search-filters">
        <b-form-group :label="$t('locationname')">
          <b-form-input
            v-model="search.locationName"
            :placeholder="$t('searchlocationname')"
          />
        </b-form-group>

        <b-button
          style="margin-top: 12px; margin-right: 10px;background-color: #02a63e; color: white; border: none;"
          variant="text-warning"
          @click="searchLocation(1)"
        >
          <b-icon
            icon="search"
            aria-hidden="true"
          />
          {{ $t('search') }}
        </b-button>
      </div>
    </div>

    <!-- Modal สำหรับเพิ่มสถานที่ -->
    <b-modal
      v-model="showAddModal"
      :title="$t('addlocation')"
      hide-footer
    >
      <b-form @submit.prevent="addDept">
        <b-form-group :label="$t('searchlocationname')">
          <b-form-input
            v-model="newDept.locationName"
            maxlength="50"
            required
          />
        </b-form-group>
        <b-button
          type="submit"
          variant="primary"
        >
          {{ $t('submit') }}
        </b-button>
      </b-form>
    </b-modal>

    <!-- Modal สำหรับแก้ไขสถานที่ -->
    <b-modal
      v-model="showEditModal"
      :title="$t('editlocation')"
      hide-footer
    >
      <b-form @submit.prevent="updateDept">
        <b-form-group :label="$t('searchlocationname')">
          <b-form-input
            v-model="editDept.locationName"
            maxlength="50"
            required
          />
        </b-form-group>
        <b-button
          type="submit"
          variant="success"
        >
          {{ $t('submit') }}
        </b-button>
      </b-form>
    </b-modal>

    <!-- ตารางแสดงสถานที่ -->
    <div class="table-wrapper">
      <b-table
        v-if="!isLoading && totalLocation > 0"
        :items="location"
        :fields="fields"
        class="location-table"
      >
        <template #cell(locationName)="data">
          {{ data.item.locationName || '' }}
        </template>
        <template #cell(actions)="data">
          <b-button
            class="b-btn"
            variant="warning"
            size="sm"
            @click="showEditDeptModal(data.item)"
          >
            {{ $t('edit') }}
          </b-button>

          <b-button
            class="b-btn"
            variant="danger"
            size="sm"
            @click="prepareDelete(data.item.id)"
          >
            {{ $t('delete') }}
          </b-button>

        </template>
      </b-table>

      <div
        v-if="!isLoading && totalLocation === 0"
        class="text-center mt-3"
      >
        <p style="font-size: 28px; font-weight: bold;">
          {{ $t('nolocationlist') }}
        </p>
      </div>

      <div
        v-if="!isLoading && totalLocation > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalLocation"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChange"
        />
      </div>
    </div>
    <!-- Confirmation Modal -->
    <b-modal
      v-model="showConfirmationModal"
      :title="$t('delconfirm')"
      :ok-title="$t('yes')"
      :cancel-title="$t('cancel')"
      @ok="confirmDelete"
    >
      <p class="my-4">
        {{ $t('confirmdelete') }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import apiMst from '@/services/masterDate'

export default {
  data() {
    return {
      location: [],
      isAdmin: false,
      activeFilter: '',
      search: {
        locationName: '',
      },
      newDept: {
        locationName: '',
      },
      editDept: {
        id: null,
        locationName: '',
      },
      showAddModal: false,
      showEditModal: false,
      currentPage: 1,
      itemsPerPage: 5,
      totalLocation: 0,
      totalPages: 0,
      showConfirmationModal: false, // สำหรับการยืนยันการลบ
      itemToDelete: null, // เก็บ ID ของรายการที่ต้องการลบ
      isLoading: true,
    }
  },
  computed: {
    fields() {
      return [
        { key: 'locationName', label: this.$t('searchlocationname'), sortable: true },
        { key: 'actions', label: this.$t('management') },
      ]
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    // เตรียมการลบและแสดงโมดอลยืนยัน
    prepareDelete(itemId) {
      this.itemToDelete = itemId
      this.showConfirmationModal = true
    },
    async handlePageChange(page) {
      this.currentPage = page // ตั้งค่า currentPage ใหม่
      await this.searchLocation(this.currentPage)
    },
    // ดำเนินการลบหลังจากการยืนยัน
    async confirmDelete() {
      if (this.itemToDelete) {
        try {
          await apiMst.delete(`/locationDel/${this.itemToDelete}`)
          this.$emit('delete-success')
          await this.fetchLocation() // รีเฟรชข้อมูลหลังจากลบ
        } catch (error) {
          console.error('Error deleting location:', error.response ? error.response.data : error.message)
          this.$bvToast.toast(this.$t('useddelete'), {
            title: this.$t('error'),
            variant: 'danger',
            solid: true,
            appendToast: true,
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-right',
          })
        }
        this.itemToDelete = null
      }
      this.showConfirmationModal = false
    },
    async initialize() {
      await this.fetchLocation()
    },
    showAddDeptModal() {
      this.newDept = {
        locationName: '',
      }
      this.showAddModal = true
    },

    async searchLocation(page = 1) {
      this.isLoading = true
      try {
        if (!this.search.locationName) {
          await this.fetchLocation(page)
          return
        }
        this.currentPage = page
        const params = {
          locationName: this.search.locationName,
          page: page - 1,
          size: this.itemsPerPage,
        }

        // ทำการเรียก API สำหรับค้นหา
        const response = await apiMst.get('/location/search', { params })

        this.location = response.data.content || []
        this.totalLocation = response.data.totalElements || 0
        this.totalPages = response.data.totalPages || 0
        console.log('Updated locations:', this.location)
      } catch (error) {
        console.error('Error fetching location:', error.response ? error.response.data : error.message)
        this.location = []
        this.totalLocation = 0
        this.totalPages = 0
        this.errorMessage = 'เกิดข้อผิดพลาดในการค้นหา'
      } finally {
        this.isLoading = false
      }
    },

    async addDept() {
      try {
        await apiMst.post('/locationAdd', this.newDept)
        this.showAddModal = false
        await this.fetchLocation() // รีเฟรชข้อมูลหลังจากเพิ่ม
        this.newDept.locationName = ''
      } catch (error) {
        console.error('Error adding location:', error.response ? error.response.data : error.message)
      }
    },
    showEditDeptModal(item) {
      this.editDept = { id: item.id, locationName: item.locationName }
      this.showEditModal = true
    },
    async updateDept() {
      try {
        await apiMst.put(`/locationUpdate/${this.editDept.id}`, this.editDept)
        this.showEditModal = false
        await this.fetchLocation() // รีเฟรชข้อมูลหลังจากแก้ไข
      } catch (error) {
        console.error('Error updating location:', error.response ? error.response.data : error.message)
      }
    },
    async fetchLocation() {
      this.isLoading = true
      try {
        const params = {
          page: this.currentPage - 1, // API uses 0-based indexing
          size: this.itemsPerPage,
        }

        const response = await apiMst.get('/locationList', { params })
        console.log('Fetched locations:', response.data)

        this.location = response.data.content
        this.totalLocation = response.data.totalElements
        this.totalPages = response.data.totalPages
      } catch (error) {
        console.error('Error fetching locations:', error.response ? error.response.data : error.message)
      } finally {
        this.isLoading = false
      }
    },
    clearFilters() {
      this.search = {
        locationName: '',
      }
      this.activeFilter = ''
    },
    showFilter(filterType) {
      this.activeFilter = filterType
    },
  },
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.search-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.search-input {
  width: 300px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.clickable-icon {
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เป็นมือเมื่อชี้ที่ไอคอน */
  margin-right: 10px; /* เพิ่มระยะห่างระหว่างไอคอน */
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}

.location-table {
  width: 100%; /* ให้ตารางเต็มความกว้าง */
  border-collapse: collapse;
}

.btn-space {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap; /* เพื่อให้ปุ่มเลื่อนลงมาในกรณีที่พื้นที่ไม่พอ */
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
  white-space: nowrap;
}

.b-btn {
  margin-right: 10px;
}

.location-table td,
.location-table th {
  font-size: medium;
}

.location-table thead {
    display: none; /* ซ่อนหัวตาราง */
  }

  @media (max-width: 768px) {
  .location-table {
    display: block; /* เปลี่ยนตารางให้เป็น block */
    overflow-x: auto; /* เพิ่มแถบเลื่อนแนวนอน */
  }
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}
</style>
